import { TreatmentHistoryProvider } from '@context/TreatmentHistory';
import TreatmentHistoryView from './TreatmentHistoryView';

const TreatmentHistory = () => {
  return (
    <TreatmentHistoryProvider>
      <TreatmentHistoryView />
    </TreatmentHistoryProvider>
  );
};

export default TreatmentHistory;
